import { Component } from "react";
import { logError } from "../../services/logging";
import "./style.css";
import { getErrorComponents } from "services/util";
import { ReactComponent as FrameBack } from "images/frame_back.svg";
import { Link } from "react-router-dom";
import { getSessionUser } from "services/authUtil";

export class ErrorBoundary extends Component<
  { [k: string]: any },
  { hasError: boolean }
> {
  constructor(props: { [k: string]: any }) {
    super(props);
    this.state = {
      hasError: false,
    } as { hasError: boolean };
  }

  componentDidUpdate(prevProps: Readonly<{ [p: string]: any }>) {
    if (this.props.pathname !== prevProps.pathname) {
      this.setState({ hasError: false });
    }
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any) {
    this.setState({ hasError: true });
    const user = getSessionUser();
    logError("Caught error in error boundary", {
      error: error,
      user_id: user && user.id,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className={"error-boundary"}>
            <div className={"container"}>
              <p>{getErrorComponents("Sorry, we've run into unexpected error")}</p>
              <Link to={"/"}>
                <button className={"btn"}>Back to Homepage</button>
              </Link>
            </div>

            <FrameBack className="frame-back" />
          </div>
        )
      );
    }

    return this.props.children;
  }
}
